import React, { useEffect } from 'react';
import { Form, Button, DatePicker, Input } from 'antd';
import { formatDate, getDisabledDates } from 'utils';
import { requiredRule } from 'utils/forms/validationRules';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import dayjs from 'dayjs';

function HospitalForm({ initialValues, disableDate, onSubmit, children }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      const { worker_id, begin_date, end_date, reason } = initialValues;

      form.setFieldsValue({
        worker_id,
        date: [dayjs(begin_date), dayjs(end_date)],
        reason,
      });
    }
  }, [initialValues]);

  const handleSubmit = async (values) => {
    const [begin, end] = values.date;

    const payload = {
      ...values,
      begin_date: formatDate(begin, 'YYYY-MM-DD'),
      end_date: formatDate(end, 'YYYY-MM-DD'),
    };

    delete payload.date;

    const isSubmitted = await onSubmit(payload);

    if (isSubmitted) {
      form.resetFields();
    }
  };

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      layout="horizontal"
      labelCol={{
        span: LABEL_SPAN,
      }}
      wrapperCol={{ span: CONTENT_SPAN }}
      labelAlign="right"
    >
      {children}

      <Form.Item
        name="date"
        label="Дата начала и окончания"
        rules={[requiredRule]}
      >
        <DatePicker.RangePicker
          format="DD.MM.YYYY"
          allowClear
          disabledDate={getDisabledDates(disableDate)}
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item
        name="reason"
        label="Номер больничного листа"
        rules={[requiredRule]}
      >
        <Input placeholder="Введите номер" allowClear />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
        <Button type="primary" htmlType="submit">
          Сохранить
        </Button>
      </Form.Item>
    </Form>
  );
}

export { HospitalForm };
